export const AGRUPADORAS_ENVIAR= "AGRUPADORAS_ENVIAR";
export const AGRUPADORAS_ERROR_AUTORIZACION = "AGRUPADORAS_ERROR_AUTORIZACION";
export const AGRUPADORAS_ERROR_ENVIO = "AGRUPADORAS_ERROR_ENVIO";
export const AGRUPADORAS_ENVIO_EXITOSO = "AGRUPADORAS_ENVIO_EXITOSO";
export const AGRUPADORAS_DESCARGAR_PLANTILLA = "AGRUPADORAS_DESCARGAR_PLANTILLA";
export const AGRUPADORAS_PLANTILLA_OBTENIDA = "AGRUPADORAS_PLANTILLA_OBTENIDA";
export const AGRUPADORAS_ERROR_OBTENIENDO_PLANTILLA = "AGRUPADORAS_ERROR_OBTENIENDO_PLANTILLA";

export const enviar = (archivoEnvio: File) => ({ type: AGRUPADORAS_ENVIAR, archivoEnvio});
export const errorAutorizacion = () => ({ type: AGRUPADORAS_ERROR_AUTORIZACION});
export const errorEnvio = () => ({ type: AGRUPADORAS_ERROR_ENVIO});
export const envioExito = () => ({ type: AGRUPADORAS_ENVIO_EXITOSO});
export const descargarPlantillaMasivo = () => ({ type: AGRUPADORAS_DESCARGAR_PLANTILLA});
export const plantillaObtenida = () => ({type: AGRUPADORAS_PLANTILLA_OBTENIDA});
export const errorObteniendoPlantilla = () => ({type: AGRUPADORAS_ERROR_OBTENIENDO_PLANTILLA});


// WEBPACK FOOTER //
// ./src/co/sura/dominio/parametros/cargar_parametros/modulos/actions.ts